import { useTranslation } from 'react-i18next';
import styles from './VersionBadge.module.css';

interface IVersionBadgeProps {
  version: number;
  overlay?: boolean; // Laid over a photo: the chip gets a solid ground.
}

export function VersionBadge({ version, overlay = false }: IVersionBadgeProps) {
  const { t } = useTranslation();
  return (
    <span className={`${styles.group} ${overlay ? styles.overlay : ''}`}>
      <span className={styles.versionChip}>{t('documents.versionBadge.label', { version })}</span>
    </span>
  );
}